export default __webpack_public_path__ + "static/1230-ee612f8cb36a39e822c829a5e5752d6c.gif";